<mat-list>
    <mat-list-item class="view-mat-list-item">
        <span matListItemTitle>
            Județ
        </span>
        <span matListItemLine>
            {{ address.judet_denumire || '-' }}
        </span>
    </mat-list-item>

    <mat-list-item class="view-mat-list-item">
        <span matListItemTitle>
            Oraș
        </span>
        <span matListItemLine>
            {{ address.oras || '-' }}
        </span>
    </mat-list-item>

    <mat-list-item class="view-mat-list-item">
        <span matListItemTitle>
            Sector
        </span>
        <span matListItemLine>
            {{ address.sector || '-' }}
        </span>
    </mat-list-item>

    <mat-list-item class="view-mat-list-item">
        <span matListItemTitle>
            Adresă
        </span>
        <span matListItemLine *ngIf="!address.adresa_text">
            {{
            'str. ' + (address.strada || '-') +
            ', nr. ' + (address.numar || '-') +
            ', bl. ' + (address.bloc || '-') +
            ', sc. ' + (address.scara || '-') +
            ', et. ' + (address.etaj || '-') +
            ', ap. ' + (address.apartament || '-')
            }}
        </span>
        <span matListItemLine *ngIf="address.adresa_text">
            {{ address.adresa_text }}
        </span>
    </mat-list-item>

    <mat-list-item class="view-mat-list-item">
        <span matListItemTitle>
            Observații
        </span>
        <span matListItemLine>
            {{ address.observatii || '-' }}
        </span>
    </mat-list-item>
</mat-list>